import uuidv4 from "uuid/v4";

export default class PaymentParameters {
  constructor(
    externalId,
    paymentNameId,
    currencyCode,
    leaseRate,
    leaseFrequency,
    startDate,
    endDate,
    paymentFrequency,
    firstPaymentDate,
    isLastPeriodDate,
    indexation,
    currencyRateParameters,
    currencyRateIncreasePercents,
    discount,
    idInDB,
    isVirtual,
    eventDate,
  ) {
    this.externalId = externalId;
    this.paymentNameId = paymentNameId;
    this.currencyCode = currencyCode;
    this.leaseRate = leaseRate;
    this.leaseFrequency = leaseFrequency;

    this.startDate = startDate;

    this.endDate = endDate;
    this.eventDate = eventDate;

    this.paymentFrequency = paymentFrequency;

    this.firstPaymentDate = firstPaymentDate;

    this.isLastPeriodDate = isLastPeriodDate;

    this.indexation = indexation;

    this.currencyRateParameters = currencyRateParameters;

    this.currencyRateIncreasePercents = currencyRateIncreasePercents;

    this.discount = discount;

    this.idInDB = idInDB;

    this.isVirtual = isVirtual;
  }

  static createFromData(data) {
    return new PaymentParameters(
      data.externalId,
      data.paymentNameId,
      data.currencyCode,
      data.leaseRate,
      data.leaseFrequency,
      data.startDate,
      data.endDate,
      data.paymentFrequency,
      data.firstPaymentDate,
      data.isLastPeriodDate,
      data.indexation,
      data.currencyRateParameters,
      data.currencyRateIncreasePercents,
      data.discount,
      data.idInDB,
      data.isVirtual
    )
  }

  static copy(data) {
    const uuidv4 = require('uuid/v4');

    const discountCopy = {
      id: data.discount.id,
      discountRate: data.discount.discountRate,
      isAuto: data.discount.isAuto,
      commentary: data.discount.commentary,
    };
    const indexationCopy = {
      id: data.indexation.id,
      indexationKindId: data.indexation.indexationKindId,
      indexationPercent: data.indexation.indexationPercent,
      firstIndexationDate: data.indexation.firstIndexationDate,
      commentary: data.indexation.commentary,
    };

    return new PaymentParameters(
      data.externalId,
      data.paymentNameId,
      data.currencyCode,
      data.leaseRate,
      data.leaseFrequency,
      data.startDate,
      data.endDate,
      data.paymentFrequency,
      data.firstPaymentDate,
      data.isLastPeriodDate,
      indexationCopy,
      data.currencyRateParameters,
      data.currencyRateIncreasePercents,
      discountCopy,
      uuidv4(),
      data.isVirtual
    );
  }

  static createNew() {
    const uuidv4 = require('uuid/v4');
    return new PaymentParameters(
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      false, {
        indexationKindId: null,
        firstIndexationDate: null,
        indexationPercent: null,
        commentary: null
      }, {
        importedId: null,
        type: null,
        fixedValue: null,
        minValue: null,
        maxValue: null
      },
      null,
      {
        id: null,
        isAuto: false,
        discountRate: null,
        commentary: null
      },
      uuidv4(),
      false
    );
  }

}
